import { LogLevel } from '../models';
import { ILoggingPublisher } from './logging-publisher.interface';

export class LoggingConsole implements ILoggingPublisher {
	public async log(title: string, body: string, level: LogLevel): Promise<void> {
		switch (level) {
			case LogLevel.Error:
				console.error(title, body); // eslint-disable-line
				break;
			case LogLevel.Info:
				console.info(title, body); // eslint-disable-line
				break;
			case LogLevel.Warning:
				console.warn(title, body); // eslint-disable-line
				break;
			default:
				break;
		}
	}
}
